// src/config.ts: runtime configuration for the browser.
// Conductor mounts /config.json into the UI container per environment (frontend_runtime scope),
// so one image runs unchanged in staging and production. Never put secrets here: it is public.
//
// Local development: commit public/config.json with safe local values, e.g.
// {
//   "API_URL": "http://localhost:3000"
// }

export interface AppConfig {
  // add the contract's frontend_runtime keys, e.g. API_URL: string;
}

let current: AppConfig | undefined;

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch('/config.json', { cache: 'no-store' });
  if (!res.ok) throw new Error(`Runtime config unavailable (HTTP ${res.status})`);
  current = (await res.json()) as AppConfig;
  return current;
}

export function config(): AppConfig {
  if (!current) throw new Error('loadConfig() must complete before the app renders');
  return current;
}

// In the entry point (e.g. src/main.tsx), load the config before rendering:
//   loadConfig().then(() => createRoot(document.getElementById('root')!).render(<App />));
// Then replace import.meta.env.VITE_API_URL / process.env.REACT_APP_* with config().API_URL, etc.
